import { Component, OnInit, Output, Input, EventEmitter, OnDestroy } from '@angular/core';
import { LinkService } from '../../services/links/links.service';
import { BorrowerValue} from 'app/models/dto/borrower-value.model';
import { MatDialog } from '@angular/material/dialog';
import { CrossSellDialogComponent } from 'app/sms/cross-sell-dialog/cross-sell-dialog.component';
import { Select } from '@ngxs/store';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';
import { SmsTemplateState } from 'app/store/lender-user/sms-templates/sms-templates.state';
import { SmsTemplate } from 'app/models/dto/sms-template.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { LenderUser } from 'app/models/dto/lender-user.model';
import { BorrowerValueState } from 'app/store/borrower-value/borrower-value.state';
import { GetSmsTemplates } from 'app/store/lender-user/sms-templates/sms-templates.actions';
import { forkJoin } from 'rxjs';
interface Borrower {
  id: number;
  canText: boolean;
  smsUnsubscribed: boolean;
  marketingSmsOptIn: boolean | undefined;
  partnerGroup: string | null;
  borrower_values?: BorrowerValue[];
  primary_contact: {
    first: string;
    last: string;
    mobilePhone: number;
  };
}

@Component({
  selector: 'app-sms-create',
  templateUrl: './sms-create.component.html',
  styleUrls: ['./sms-create.component.scss']
})
export class SmsCreateComponent implements OnInit, OnDestroy {

  @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;
  @Select(SmsTemplateState.smsTemplates) templates$: Observable<SmsTemplate[]>;

  @Input() borrower: Borrower;
  @Input() links: any;
  @Output() newSms = new EventEmitter<object>();

  placeholder = 'Type a new text message...';
  templateId: number | null;
  clearDraft: boolean;
  content = '';
  quillEditorRef;
  selectionRange: {index: number, length: number};
  showMissingNumberAlert = false;
  marketingSmsOptIn$: Observable<BorrowerValue | null>;
  marketingSmsOptIn: BorrowerValue | null;
  selectedTemplate: any;
  loading = true;

  constructor(
    private linkService: LinkService,
    public dialog: MatDialog,
    private store: Store,
    ) {
  }

  ngOnInit() {
    this.clearDraft = false;
    const json = localStorage.getItem(`borrower-${this.borrower.id}-smsDraft`) || null;
    if (json !== null) {
      const draft = JSON.parse(json);
      this.content = draft !== null ? draft : this.content;
    }
    if (!!this.borrower.primary_contact && !this.borrower.primary_contact.mobilePhone) {
      this.showMissingNumberAlert = true;
    }

    this.marketingSmsOptIn$ = this.store.select(BorrowerValueState.valueByAlias)
      .pipe(map(filterFn => filterFn('marketingSmsOptIn')));

    this.marketingSmsOptIn$.subscribe(bv => {
        this.marketingSmsOptIn = bv;
      });

    forkJoin([
      this.store.dispatch(new GetSmsTemplates()),
    ]).subscribe(() => {
      this.loading = false;
    });
  }

  ngOnDestroy() {
    if (this.clearDraft === true) {
      return;
    } else {
      localStorage.setItem(`borrower-${this.borrower.id}-smsDraft`, JSON.stringify(this.content));
    }
    this.clearDraft = false;
  }

  handleSubmitSms(): void {
    try {
      const smsData = {
        content: this.content.trim(),
        templateId: this.templateId ? this.templateId : null,
      };

      this.newSms.emit(smsData);
      this.selectedTemplate = null;
      this.content = '';
      localStorage.removeItem(`borrower-${this.borrower.id}-smsDraft`);
    } catch (e) {
      console.error('Error submitting sms: ', e);
    }
  }

  handleEmoji($event): void {
      this.quillEditorRef.focus();
      const index = this.selectionRange.index || 0;
      this.quillEditorRef.insertText(index, $event.emoji.native, 'user');
      this.quillEditorRef.setSelection(index + $event.emoji.native.length + 2, 0, 'user');
  }

  handleEditorCreated(editorInstance: any) {
    this.quillEditorRef = editorInstance;
    this.quillEditorRef.focus();
  }

  handleSelectionChange(selectionRange) {
    this.rememberSelectionRange(selectionRange);
  }

  handleContentChange() {
    if (!this.quillEditorRef) {
      return;
    }
    this.rememberSelectionRange(this.quillEditorRef.getSelection());
  }

  rememberSelectionRange(selectionRange) {
    if (!selectionRange) {
      return;
    }
    this.selectionRange = selectionRange;
  }

  chooseTemplate(event) {
    if (!event) {
      this.reset();
    } else {
      this.selectedTemplate = event;
      const html = this.selectedTemplate.content.replace(/<\/div>/g, '\n'); //add new lines in place of <div></div>
      const cleanedContent = html.replace(/<[^>]*>/g, ''); //remove html from template as Sms does not support it.

      this.content = cleanedContent;
      this.templateId = this.selectedTemplate.id;
    }
  }

  reset(): void {
    this.selectedTemplate = null;
    this.content = '';
  }

  getLinks() {
    this.links = this.linkService.getLinks(this.borrower);
  }

  handleInsertLink(handler) {
    handler().subscribe(url => {
      this.quillEditorRef.focus();
      this.quillEditorRef.insertText(this.selectionRange.index || 0, url, 'user');
      this.quillEditorRef.setSelection(this.selectionRange.index + url.length + 1, 0, 'user');
    });
  }

  openOptInStatusModal() {
    const dialogRef = this.dialog.open(CrossSellDialogComponent, {
      data: {
        borrowerId: this.borrower.id,
        marketingSmsOptIn: this.marketingSmsOptIn
      }
    });
  }
}
